export default __webpack_public_path__ + "static/media/Capture.5c6cba59.JPG";